import { render } from "./BaseGallery.vue?vue&type=template&id=6d768544&scoped=true"
import script from "./BaseGallery.vue?vue&type=script&lang=js"
export * from "./BaseGallery.vue?vue&type=script&lang=js"

import "./BaseGallery.vue?vue&type=style&index=0&id=6d768544&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6d768544"

export default script